module.exports = {"confirm_nationality":"Bestätige deine Nationalität","hint":"Das Land in deinem Reisepass","other":"Andere Nationalität","nationality":"Staatsangehörigkeit"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/nationality.json
// module id = 492
// module chunks = 248 1681